<template>
    <section v-if="parseInt(data.data.octave_graphs_enabled)" class="octave-graphs-container">
        <h2 v-html="translate('octave-graphs')"/>

        <div class="engine-start-time-container">
            <div class="octave-graphs-data" :id="id">dane</div>
        </div>
        <!-- NVS-80 -->
        <div class="all_noise_values">{{ translate('all_noise_values') }}</div>
    </section>
</template>

<script>
    import { octaveGraphs } from '../../octaveGraphs'

    export default {
        name: "octaveGraphs",
        props: ['data', 'graphs', 'id'],
        methods: {
            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            getVariable(code) {
                let arg = {
                    type: 'getVariable',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);
                if (arg.out === '' || null) {
                    return {variableTranslation: code, variableDefaultKey: 0, variableValues: []};
                }
                return arg.out;
            },
        },
        mounted() {
            let graphs = new octaveGraphs(document.getElementById(this.id), this.$store, this.data, this.graphs);
        }
    }
</script>